import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError, EMPTY, switchMap } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const oidcService = inject(OidcSecurityService);

  return oidcService.getAccessToken().pipe(
    switchMap(token => {
      const newReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
      return next(newReq);
    }),
    catchError(err => {
      if (err?.status === 401) {
        oidcService.authorize();
        return EMPTY;
      }

      return throwError(() => err);
    })
  );
}
